export const parseQueryString = queryString => {
    if (queryString === 0 || queryString === undefined || queryString === '') { return {}; }
    const params = {};
    // Split into key/value pairs
    const queries = queryString.slice(1).split("&");
    // Convert the array of strings into an object
    for (let idx = 0; idx < queries.length; idx++) {
        const temp = queries[idx].split('=');
        params[temp[0]] = temp[1] === 'null' ? null : temp[1];
    }
    return params;
};